<template>
    <div class="">
        <form ref="form" class="">
            <div class="uk-form-label">Ratings</div>
            <div v-for="(cat, index) in ratingCategories" class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-width-1-2">
                    <input type="text" class="uk-input" v-model="cat.name" />
                </div>
				<div class="uk-width-1-4">
					<label class="uk-form-label">
						<input class="uk-checkbox" type="checkbox" v-model="cat.is_optional" />
						Optional
					</label>
				</div>
                <div class="uk-width-1-4 uk-text-left uk-padding-small" style="padding-bottom: 0;padding-top: 8px;cursor: pointer;" @click="dropRating(index)">
                    <i class="far fa-trash-alt"></i>
                </div>

            </div>
            <a class="standard-text" @click="addRating">
                <i class="fas fa-plus-circle"></i> Add Additional Rating Criteria
            </a>
            <div class="uk-margin-large-bottom"></div>
        </form>
        <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Update</button>
    </div>
</template>
<script>
    import EventBus from "../events";
    export default {

        props: {
            get:{
                type:String,
                default: '/api/settings/default-categories'
            },
            post:{
                type:String,
                default: '/api/settings/default-categories'
            }
        },

        data(){
            return {
                ratingCategories:[{
                    id:null,
                    name:"",
					is_optional:false
                }]
            }
        },

        mounted(){
            axios.get(this.get)
                .then((pack) => this.setCategories(pack),(pack) => this.setCategories(pack));
        },

        methods: {
            submitForm() {
                let data = new FormData();
                let uri = this.post;

                data.append("rating_categories", JSON.stringify(this.ratingCategories));
                axios.post(uri, data)
                    .then((pack) => this.updateForm(pack),(pack) => this.updateForm(pack));
            },
            setCategories(pack){
                if(pack.data.success){
                    this.ratingCategories = pack.data.data;
                }
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            },
            addRating(){
                this.ratingCategories.push({
                    id:null,
                    name:"",
                    is_optional:false
                });
            },
            dropRating(i){
                this.ratingCategories.splice(i, 1);
            },
            updateForm(pack){
                if(pack.data.success){
                    EventBus.fireEvent("message", "Updated default categories.");
                } else {
                    EventBus.fireEvent("error", "Failed to update.");
                }
            }
        },

        watch:{

        }

    }
</script>
<style scoped>
    .uk-grid > *{
        padding-left: 2vw;
    }
</style>
